<template>
  <v-flex xs12>
    <v-card>
      <v-card-title class="px-3 pt-3">
        <h4 class="font-weight-bold">オペレーターの状態のカスタマイズ</h4>
      </v-card-title>
      <v-divider class="my-1 mx-3"></v-divider>
      <v-layout px-4 py-2 pb-3 row wrap>
        <v-flex xs12 sm12 md8>
          <v-card flat style="border: 0">
            <v-layout row wrap>
              <v-flex xs12 sm12 md6>
                <v-data-table id="scroll-target" style="min-height:300px;max-height:300px;"
                              class="scroll-y px-2 py-2"
                              v-model="selected"
                              select-all
                              :headers="headers" :items="statuses" hide-actions>
                  <template slot="headers" slot-scope="props">
                    <tr>
                      <th style="width:15px">
                        <v-checkbox :input-value="props.all"
                                    @click.native="toggleAll" class="pl-2 mt-2"></v-checkbox>
                      </th>
                      <th
                        v-for="header in props.headers" :key="header.text">
                        {{ header.text }}
                      </th>
                    </tr>
                  </template>
                  <template slot="items" slot-scope="props">
                    <tr :active="props.selected" return-object @click="editStatusView(props.item)" class="cursor"
                        :style="[props.item.id === selectIndex ? activeClass: '']">
                      <td class="pl-4">
                        <v-checkbox v-model="props.selected" hide-details></v-checkbox>
                      </td>
                      <td class="text-xs-center">{{ props.item.statusType }}</td>
                    </tr>
                  </template>
                </v-data-table>
                <v-flex>
                  <v-layout justify-center px-3 py-3>
                    <v-btn slot="activator" class="registration" @click="addStatusView">追加</v-btn>
                    <v-btn slot="activator" class="deletion" :disabled="selected.length < 1" @click="deleteStatus">
                      削除
                    </v-btn>
                  </v-layout>
                </v-flex>
              </v-flex>
              <v-flex xs12 sm12 md6>
                <v-card flat>
                  <v-card-title class="px-3 pt-3">
                    <h4 class="font-weight-bold">状態値の登録/修正</h4>
                  </v-card-title>
                  <v-divider class="my-1 mx-3"></v-divider>
                  <v-form v-model="valid" ref="form" lazy-validation>
                    <v-flex class="px-4" style="min-height: 250px">
                      <p class="body-1 no_margin">状態名</p>
                      <v-text-field single-line outline v-model="statusType" label="状態名" clearable></v-text-field>
                    </v-flex>
                    <v-flex>
                      <v-layout align-end justify-end fill-height px-3 py-3>
                        <v-btn slot="activator" class="registration" v-if="useAdd" @click="addStatus">登録</v-btn>
                        <v-btn slot="activator" class="correct" v-if="useEdit" @click="editStatus">修正</v-btn>
                      </v-layout>
                    </v-flex>
                  </v-form>
                </v-card>
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>
        <v-flex sm12 md4 pl-2 pr-4 pb-3>
          <div>
            <p class="body-1">
              * オペレーターの状態値をカスタマイズできます。<br>
              * 状態値の変更後、保存時に右上のオペレーターの状態変更に適用されます。 <br>
              * 状態値を変更/追加した後 <b>保存ボタン</b>を必ず押してください!<br>
            </p>
          </div>
        </v-flex>
      </v-layout>
    </v-card>
  </v-flex>
</template>

<script>
export default {
  props: ['brandId'],
  data: () => {
    return ({
      selected: [],
      statusType: '',
      statuses: ['こんにちは'],
      useAdd: true,
      useEdit: true,
      selectIndex: '',
      valid: true,
      activeClass: {
        backgroundColor: '#FFFDE7'
      },
      headers: [
        {text: 'オペレーターの状態', sortable: false, value: 'statusName'}
      ]
    })
  },
  methods: {
    toggleAll () {
      if (this.selected.length) this.selected = []
      else this.selected = this.statuses.slice()
    },
    addStatusView () {
      this.$alertMsg('状態値 view')
    },
    deleteStatus () {
      this.$alertMsg('状態値 削除')
    },
    editStatusView () {
      this.$alertMsg('状態値 view')
    },
    addStatus () {
      this.$alertMsg('状態値 追加')
    },
    editStatus () {
      this.$alertMsg('状態値 修正')
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/menus/system/brand_status_management.vue